<template>
    <div class="not-found">
      <h1>404</h1>
      <p>La página que buscas no existe.</p>
      <router-link to="/">Volver al inicio</router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: "NotFoundPage"
  };
  </script>
  
  <style scoped>
  .not-found {
    text-align: center;
    margin-top: 50px;
  }
  h1 {
    font-size: 5rem;
    color: #ff4757;
  }
  </style>
  